import { useEffect, useState } from 'react';
import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useNavigate } from 'react-router';
import { useTranslation } from '../../useTranslation';
import { ISlackValues } from '../../../views/SlackIntegrationPage';
import useGetAuthUrlForSlack from './useGetAuthUrlForSlack';

const useGetUserSlackIntegrationOnMount = () => {
    const { t } = useTranslation('slackIntegration');
    const userApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { getRedirectionUrl } = useGetAuthUrlForSlack();

    const navigate = useNavigate();
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<ISlackValues>({
        id: '',
        isActive: false,
        user: {
            id: '',
            isActive: false,
        },
        channels: [],
    });

    const getUserSlackInfo = () => {
        const { exec, abort } = userApi.getUserSlackInfo({
            onSuccess: res => {
                setData(res.body);
            },
            onError: (_, code) => {
                if (code === 404) {
                    getRedirectionUrl();
                } else {
                    toastHandler.push('error', t('connection.FAILED_MESSAGE_TITLE'), t('connection.FAILED_MESSAGE_DESCRIPTION'));
                    navigate('/integrations');
                }
            },
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    };

    useEffect(() => {
        getUserSlackInfo();
    }, []);

    return { data, isReady };
};

export default useGetUserSlackIntegrationOnMount;
